const useOnEnterExecute = (
  callback: (e: React.KeyboardEvent<HTMLInputElement>) => void
): React.KeyboardEventHandler<HTMLInputElement> => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      callback(e);
    }
  };

  return handleKeyDown;
};

export default useOnEnterExecute;
